var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box"},[_c('img',{staticClass:"logo transition",attrs:{"src":require("@/assets/icon/logo.jpg"),"alt":""},on:{"click":function($event){return _vm.$router.push('/home')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }